module.exports = __webpack_public_path__ + "static/media/Alfinete.0f24aaae.svg";